var $ = require("jquery");
import { isLargeNonTouchDevice } from './gsap/globals.js';

if($('body.home').length && isLargeNonTouchDevice()) {
  // Immediately reset scroll before anything loads
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // Force scroll to top on page load
  window.addEventListener('beforeunload', () => {
    window.scrollTo(0, 0);
  });

  window.scrollTo(0, 0);

  // Or use this on DOM ready to ensure it runs after rendering
  window.addEventListener('load', () => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1); // Delay by 1ms to ensure styles/layout are rendered
  });
}

import './gsap/page-loader.js';
import './gsap/animate-chars.js';
import './gsap/custom-cursors.js';
import './gsap/magnetic-buttons.js';
import './gsap/heading-load.js';
import './gsap/background-fade.js';

// HP ANIMATIONS
import './gsap/hp-splash.js';
import './gsap/hp-about.js';
import './gsap/hp-latest-news.js';

// BLOCK ANIMATIONS
import './gsap/pinned-slider.js';
import './gsap/product-frames.js';
import './gsap/slider-load.js';
import './gsap/image-enlarge.js';
import './gsap/project-cards-load.js';
import './gsap/image-text-parallax.js';
import './gsap/hero-image.js';
import './gsap/center-text.js';
import './gsap/stats-ticker.js';
import './gsap/text-fade.js';
import './gsap/parallax-image.js';
import './gsap/image-marquee.js';
import './gsap/offices.js';
import './gsap/team-card.js';
